import { FiHome, FiSettings, FiMail, FiAlertOctagon, FiBell } from "react-icons/fi";

export const navItems = [
  {
    label: "Home",
    path: "/",
    children: [],
    icon: FiHome,
  },
  {
    label: "App Config",
    path: "/featureflags",
    children: [],
    icon: FiSettings,
  },
  {
    label: "Messages",
    path: "/messages",
    icon: FiMail,

    children: [
      { label: "All Messages", path: "/messages" },
      { label: "New Message", path: "/new-message" },
    ],
  },
  {
    label: "Privacy Policies",
    path: "/policy",
    icon: FiAlertOctagon,
    children: [
      { label: "All Policies", path: "/policy" },
      { label: "New Policy", path: "/add-policy" },
    ],
  },
  {
    label: "Push Notifications",
    path: "/push-notification",
    icon: FiBell,
    children: [
      { label: "All notifications", path: "/push-notification" },
      { label: "New notification", path: "/new-notification" },
    ],
  },
];
